var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStopwatch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 21,
  viewBox: "0 0 19 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "nonzero",
  d: "M9.5 2.52a8.82 8.82 0 1 0 0 17.64 8.82 8.82 0 0 0 0-17.64Zm0 16.8a7.98 7.98 0 1 1 7.98-7.98 7.99 7.99 0 0 1-7.98 7.98ZM6.56 1.26a.42.42 0 0 1 .42-.42h5.04a.42.42 0 1 1 0 .84H6.98a.42.42 0 0 1-.42-.42Zm10.08 2.1a.84.84 0 1 1 1.68 0 .84.84 0 0 1-1.68 0Zm-2.685 3.525a.42.42 0 0 1 0 .594L10.634 10.8a1.272 1.272 0 1 1-.594-.594l3.32-3.32a.42.42 0 0 1 .595 0Z"
})));
export default SvgStopwatch;